/* eslint-disable no-empty-pattern */
import Vue from "vue";
import Vuex from "vuex";
import * as socketio from "../plugins/socketio";
import chat from "./chat";
import game from "./game";
import auth from "./auth";
import notification from "./notification";
import tabs from "./tabs";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  actions: {
    SEND_EVENT({}, event) {
      socketio.sendEvent(event);
    }
  },
  modules: {
    tabs,
    chat,
    game,
    auth,
    notification
  }
});
